import Contact from "../contact/Contact";
import Experience from "../experience/Experience";
import Footer from "../footer/Footer";
import Header from "../header/Header";
import Hero from "../hero/Hero";
import Skills from "../skills/Skills";
import "./Main.css";

function Main() {
    return (
        <div id="main">
            <Header />
            <Hero />
            <Experience />
            <Skills />
            <Contact />
            <Footer />
        </div>
    )
}

export default Main;
